module.exports = __webpack_public_path__ + "static/media/celula.40782e9b.jpg";